import { render, staticRenderFns } from "./EventTabCommunication.vue?vue&type=template&id=19a76982&"
import script from "./EventTabCommunication.vue?vue&type=script&lang=js&"
export * from "./EventTabCommunication.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports